import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Group } from 'src/app/models/group';
import { PedidoCadastro } from 'src/app/models/pedido-cadastro';
import { Purchase } from 'src/app/models/purchase';
import { GroupService } from 'src/app/services/group/group.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';

@Component({
  selector: 'app-nova-compra-grupo',
  templateUrl: './nova-compra-grupo.component.html',
  styleUrls: ['./nova-compra-grupo.component.css']
})
export class NovacompraGrupoComponent implements OnInit {

  public currentUser;
  public groups: Array<Group>;
  public search = '';
  public allGroups: Array<Group>;
  public currentPedidoValue: PedidoCadastro;
  private routeSubscription: Subscription;
  public currentPurchaseValue: Purchase;
  public arq= false;

  constructor(private router: Router, private groupService: GroupService,
              private pedidoDataService: PedidoDataService,
              private route: ActivatedRoute,
              private pedidoService: PedidoService,
              private alertService: NewAlertService) {
    this.currentUser = JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser));
   }

  ngOnInit() {
      this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
      this.buscarGrupos();
      this.routeSubscription = this.route.queryParamMap.subscribe(params => {
        this.arq = params.get('arq')? true : false;
    });
  }

  buscarGrupos() {

    let product = [];
    for(let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++)
        product[i] = this.currentPurchaseValue.purchaseItens[i].order.productGuid;
      this.groupService.getGroupsByBeneficio(this.currentUser.token.assignorGuid, product).subscribe(response => {
          if (response.status === 1) {
              this.groups = response.result;
              this.allGroups = response.result;
          }
      });
  }

  filtrar() {
    this.groups.forEach(e => {
      e.selecionado = false;
    });
    this.groups = this.allGroups.filter(x => x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(this.search.toLowerCase()));
  }

  limparFiltros() {
    this.search = '';
    this.groups = this.allGroups;
  }

  activate(item: Group) {
    this.groups.forEach(e => {
      e.selecionado = false;
    });
    item.selecionado = !item.selecionado;
  }

  previous() {
    this.router.navigate(['create'], { relativeTo: this.route.parent });
  }

  next() {
    this.groupService.setGrupo(this.groups.find(x => x.selecionado));
    if(this.arq){
      this.router.navigate(['arquivo'], { relativeTo: this.route.parent });
    } else {
      this.router.navigate(['selecionargrupocolaborador'], { relativeTo: this.route.parent });
    }
  }

  public savePedido() {

    this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, this.currentPurchaseValue).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                this.currentPurchaseValue.purchaseId = response.result.purchaseId;
                this.currentPurchaseValue.purchaseItens.forEach(obj => {
                    this.currentPurchaseValue.purchaseId = response.result.purchaseId;
                });
                this.pedidoDataService.setCurrentPedidoValue(this.currentPedidoValue);
                this.alertService.success(response.message);
            } else {
                this.alertService.error(response.message);
            }

        },
        error => {
            this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
        }
    );
}

}
